<template>
  <div>
    <div class="notification-header">
      <span class="notification-title">NOTIFICATIONS</span>
      <div class="notifications-number" v-if="numberOfNotifications > 0">
        {{ numberOfNotifications }}
      </div>
    </div>
    <div class="notifications">
      <RequestListDropdown
        :request="request"
        v-for="request in notificationsToShow"
        :key="request._uId"
        @button="setSeen(request)"
      />
    </div>
    <span class="no-message" v-if="notifications.length === 0">No new notifications</span>
    <div class="more-requests">
      <router-link id="activity-link" to="/s-app/notifications"
        >View all notifications ></router-link
      >
    </div>
  </div>
</template>

<script>
// !!!!! THE CODES BELOW ARE COMMENTED UNTIL WE MAKE SURE THE FUNCTIONALITY WONT BE USED AGAIN !!!!!
import RequestListDropdown from "@/material-components/molecules/RequestListDropdown.vue";
// import itemType from "@/enum/item-type";
// import itemStatus from "@/enum/item-status";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
export default {
  name: "SRequestsDropdown",
  props: ["notifications", "numberOfNotifications", "notificationsToShow"],
  mixins: [UserHelperVue, ItemHelperVue],
  components: {
    RequestListDropdown,
  },
  methods: {
    // setNotifications() {
    //   this.setRequestsAsSeen();
    //   this.setSentAsSeen();
    //   this.setReceivedAsSeen();
    // },
    // setRequestsAsSeen() {
    //   const notifications = this.notifications;
    //   const unseenNotifications = notifications.filter((notif) => !notif.seen);
    //   const allUnseenRequestsIds = unseenNotifications.map((notif) => notif.id);

    //   if (allUnseenRequestsIds.length > 0)
    //     this.setReadRequests({ requestIds: allUnseenRequestsIds });
    // },
    // mountNotif(notif, key1, key2, key3, key4) {
    //   if (notif.item.posterId === this.loggedUser.id) { 
    //     if (
    //       notif.item.type === itemType[key1] ||
    //       notif.item.type === itemType[key2]
    //     ) {
    //       return true
    //     }
    //   } else {
    //     if (
    //       notif.item.type === itemType[key3] ||
    //       notif.item.type === itemType[key4]
    //     ) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    // setSentAsSeen() {
    //   const notifications = this.notifications;
    //   const today = new Date();
    //   const unseenNotifications = notifications.filter((notif) => {
    //     let d10 = new Date(notif.changeSituationAt);
    //     d10.setDate(d10.getDate() + 10);
    //     if (
    //       notif.notification === "pending" &&
    //       !notif.sentSeen &&
    //       today >= d10 &&
    //       notif.item.status === itemStatus.WAITING
    //     ) {
    //       if (this.mountNotif(notif, 'GIVE', 'LEND', 'RECEIVE', 'BORROW')) return true
    //     }
    //   });
    //   const allUnseenSentIds = unseenNotifications.map((notif) => notif.id);

    //   if (allUnseenSentIds.length > 0)
    //     this.setReadSent({ requestIds: allUnseenSentIds });
    // },
    // setReceivedAsSeen() {
    //   const notifications = this.notifications;
    //   const today = new Date();
    //   const unseenNotifications = notifications.filter((notif) => {
    //     let d20 = new Date(notif.changeSituationAt);
    //     d20.setDate(d20.getDate() + 20);
    //     if (
    //       notif.notification === "pending" &&
    //       !notif.receivedSeen &&
    //       today >= d20 &&
    //       (notif.item.status === itemStatus.WAITING ||
    //         notif.item.status === itemStatus.SENT)
    //     ) {
    //       if (this.mountNotif(notif, 'RECEIVE', 'BORROW', 'GIVE', 'LEND')) return true
    //     }
    //   });
    //   const allUnseenReceivedIds = unseenNotifications.map((notif) => notif.id);

    //   if (allUnseenReceivedIds.length > 0)
    //     this.setReadReceived({ requestIds: allUnseenReceivedIds });
    // },

    setSeen(request) {
      const index = this.notifications.indexOf(request);

      if (index !== -1){
        this.notifications[index].seen = 1;
        this.setReadRequests({ requestIds: [this.notifications[index].id] });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-header {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 5px;
  width: 100%;
  border-bottom: solid;
  border-color: $primary;
}
.notification-title {
  font-size: 1.2rem !important;
  font-weight: bold;
  padding-left: 10px;
}
.more-requests {
  text-align: center;
  margin-bottom: 10px;
}
#activity-link:active {
  background-color: transparent;
}
.notifications{
  max-height: 25em;
  overflow-y: auto;
  margin-bottom: 15px;
}
</style>